import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({

  container: {
    width: '100%',
    height: '100%',
    minHeight: '780px',
    alignItems: 'center',
    backgroundImage: `url(${require('./assets/headerBg.jpg')})`,
    backgroundSize: '1920px 363px',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
  },
  container1: {
    width: '100%',
    minHeight: '780px',
    alignItems: 'center',
    backgroundImage: `url(${require('./assets/headerSenior1.png')})`,
    backgroundSize: '1920px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
  },
  header: {
    width: '100%',
    alignItems: 'flex-start',
  },
  headerIcon: {
    marginTop: 28,
    marginLeft: 20,
    width: '58px',
  },
  hyHeaderIcon: {
    marginTop: 28,
    marginLeft: 20,
    width: '90px',
  },
  contentContainer: {
    width: '100%',
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
    marginTop: '24px',
  },
  text: {
    textAlign: 'center',
    fontSize: 40,
    fontFamliy: 'FZLTZHK--GBK1-0;',
    color: 'rgba(255,255,255,1)',
    lineHeight: '46px',
    fontWeight: 'normal',
  },
  title: {
    width: '360px',
    marginTop: '21px',
    fontSize: '24px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(255,255,255,1)',
    lineHeight: '33px',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  line: {
    width: '110px',
    height: '1px',
    backgroundColor: 'rgba(255,255,255,0.5)',
  },
  subTitle: {
    marginTop: '40px',
    fontSize: '16px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(255,255,255,0.5)',
    lineHeight: '22px',
  },
  time: {
    textAlign: 'center',
    marginTop: '40px',
    color: 'rgba(135,143,152,1)',
    fontFamliy: 'PingFangSC-Regular',
    lineHeight: '17px',
    fontSize: '12px',
    fontweight: 400,
  },
  buttons: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '130px',
  },
  buttonSenior: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '130px',
  },
  button: {
    marginTop: '46px',
    borderRadius: '3px',
    width: 120,
    height: 40,
    color: '#FFFFFF',
  },
  buttonText: {
    lineHeight: '20px',
    fontSize: 14,
    fontFamliy: 'PingFangSC-Regular',
  },
  buttonTextAgian: {
    lineHeight: '20px',
    fontSize: 14,
    fontFamliy: 'PingFangSC-Regular',
    color: 'rgba(50,54,58,1)',
  },
  notStart: {
    backgroundColor: '#385DAE',
    ':hover': {
      backgroundColor: '#4769b4',
    },
  },
  again: {
    backgroundColor: 'white',
    ':hover': {
      backgroundColor: '#F6F8F9',
    },
    marginRight: '20px',
    border: '1px solid rgba(135,143,152,1)',
  },
  continue: {
    backgroundColor: '#385DAE',
    ':hover': {
      backgroundColor: '#4769b4',
    },
  },
  completed: {
    backgroundColor: '#385DAE',
    ':hover': {
      backgroundColor: '#4769b4',
    },
  },
  modalAlertText: {
    fontSize: 14,
    marginTop: 20,
    marginBottom: 40,
  },
  alertText: {
    display: 'inline-block',
    marginTop: 10,
  },
  tipText: {
    color: 'red',
  },
  tipText1: {
    color: '#3399FF',
  },
  subjects: {
    marginTop: '40px',
    flexDirection: 'row',
    width: '1000px',
    height: '164px',
    background: 'rgba(255,255,255,1)',
    boxShadow: '0px 2px 20px 0px rgba(0,0,0,0.08)',
    borderRadius: '8px',
    justifyContent: 'space-around',
    padding: '0 40px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
  },
  subject: {
    paddingTop: '40px',
  },
  subjectTitle: {
    fontSize: '16px',
    color: 'rgba(50,54,58,1)',
    lineHeight: '22px',
    flexDirection: 'row',
    marginBottom: '12px',
    alignItems: 'center',
  },
  subjectItem: {
    fontSize: '12px',
    color: 'rgba(135,143,152,1)',
    lineHeight: '17px',
    flexDirection: 'row',
    marginTop: '8px',
  },
  num: {
    marginLeft: 8,
    color: 'rgba(50,54,58,1)',
  },
  image: {
    width: 37,
    height: 16,
    marginLeft: 8,
  },
  bottom: {
    width: '100%',
    height: 87,
    textAlign: 'center',
    justifyContent: 'center',
    backgroundImage: `url(${require('./assets/bottomBg.png')})`,
    backgroundSize: '1920px 83px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    fontSize: '12px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(135,143,152,1)',
    lineHeight: '17px',
  },
  question: {
    fontSize: '12px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(51,153,255,1)',
    lineHeight: '17px',
    marginTop: '20px',
    cursor: 'pointer',
  },
  questionText: {
    marginTop: '20px',
    flexDirection: 'row',
    fontSize: '14px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(50,54,58,1)',
    lineHeight: '24px',
  },
  questionIndex: {
    width: '20px',
    height: '20px',
    marginRight: '20px',
  },
  buttonC: {
    flexDirection: 'row',
  },
},
);




// WEBPACK FOOTER //
// ./src/components/entrance/styles.js